import { msg } from '@lingui/macro';
import { IconHistory } from '@tabler/icons-react';
import type { ImporterDescriptor } from '../../../descriptors/types';

const descriptor: ImporterDescriptor = {
  id: 'productDataImport',
  status: 'legacy',
  category: 'product-data',
  icon: IconHistory,
  title: msg`Product updates (legacy)`,
  shortTitle: msg`Product updates (legacy)`,
  whenToUse: msg`Update existing portfolio products using Bottlebooks ID. Use the Product data import for new flows.`,
  outputDescription: msg`Updates portfolio products keyed by Bottlebooks ID (legacy).`,
  intents: ['Legacy product update by Bottlebooks ID'],
  keywords: ['legacy', 'Bottlebooks ID', 'update', 'product'],
  synonyms: [],
  inputHints: {
    fileTypes: ['xlsx'],
    sampleHeaders: ['Bottlebooks ID'],
    requiredColumns: ['Bottlebooks ID'],
  },
};

export default descriptor;
